<template>
  <div class="mt-2">
    <h5>{{ getActor.name }} {{getMin}} - {{getMax}}</h5>
    <b-row class="mt-5">
      <b-col cols="2" class="d-flex align-items-center justify-content-end">
        <jalousie-up v-if="hasPosition" class="text-large svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMin" />
        <jalousie-close v-else-if="hasLamel" class="text-large svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMin" />
        <font-awesome-icon v-else :icon="getAdjustIcon" @click="setMin" class="cursor-pointer" />
      </b-col>
      <b-col cols="8" class="d-flex">
        <vue-slider
          v-model="value"
          :min="getMin"
          :max="getMax"
          :process="false"
          @drag-end="dragEnd"
          :dot-options="dotOptions"
          :order="false"
          :clickable="false"
          class="align-self-center w-100"
        >

        </vue-slider>
      </b-col>
      <b-col cols="2" class="text-large d-flex align-items-center justify-content-start">
        <jalousie-down v-if="hasPosition" class="svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMax" />
        <jalousie-open v-else-if="hasLamel" class="svg-inline--fa.fa-w-10 svg-inline--fa cursor-pointer" @click.native="setMax" />
        <font-awesome-icon v-else :icon="getAdjustIcon" @click="setMax" class="cursor-pointer" />
      </b-col>
    </b-row>
    <div v-if="groupValue" class="text-center">
      <strong class="text-large">{{ groupValue }}{{ getVar.unit }}</strong>
    </div>
  </div>
</template>

<script>
import ControlMixin from '@/components/service-groups/controls/controlMixin';
import VueSlider from 'vue-slider-component';
import JalousieOpen from '@/components/icons/design/JalousieOpen';
import JalousieUp from '@/components/icons/design/JalousieUp';
import JalousieClose from '@/components/icons/design/JalousieClose';
import JalousieDown from '@/components/icons/design/JalousieDown';

export default {
  name: 'Slider',
  mixins: [
    ControlMixin,
  ],
  data() {
    return {
      sliderValue: this.defaultValue ? this.defaultValue : 0,
    };
  },
  computed: {
    value: {
      get() {
        return [...this.vars.map(varItem => varItem.value), this.sliderValue];
      },
      set(value) {
        this.sliderValue = value[value.length - 1];
      },
    },
    hasPosition() {
      return this.getActor.argument === 'POSITION';
    },
    hasLamel() {
      return this.getActor.argument === 'LAMELL';
    },
    getAdjustIcon() {
      return this.getVar.icon ? this.getVar.icon : 'angle-up';
    },
    getMin() {
      return this.getVar.validation?.min ? this.getVar.validation.min : 0;
    },
    getMax() {
      return this.getVar.validation?.max ? this.getVar.validation.max : 100;
    },
    groupValue() {
      if (this.vars.every(varItem => varItem.value === this.getVar.value)) {
        return this.getVar.value;
      }
      return undefined;
    },
    getValue() {
      return this.value[this.value.length - 1];
    },
    dotOptions() {
      return this.vars.map((varItem) => {
        return {
          disabled: true,
          tooltip: 'always',
          tooltipStyle: {
            backgroundColor: '#b7b7bb',
          },
        };
      });
    },
  },
  methods: {
    dragEnd() {
      this.setVarsToValue(this.vars, this.getValue);
    },
    setMin() {
      this.setVarsToValue(this.vars, this.getMin);
    },
    setMax() {
      this.setVarsToValue(this.vars, this.getMax);
    },
  },
  components: {
    VueSlider,
    JalousieOpen,
    JalousieUp,
    JalousieClose,
    JalousieDown,
  },
};
</script>

<style scoped>

</style>
